// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuctionActivityPunkTitle_wrapper__1amxM"};